import React from 'react';

const Breadcrumb = ({ currentPath, setCurrentPath }) => {
    const paths = currentPath.split("/").filter(Boolean);

    return (
        <nav className="breadcrumb bg-light p-2 rounded mb-0 w-100">
            <span
                className="breadcrumb-item text-primary"
                style={{ cursor: "pointer" }}
                onClick={() => setCurrentPath(null)}
            >
                Home
            </span>
            {paths.map((segment, index) => {
                const pathToSegment = paths.slice(0, index + 1).join("/");
                return (
                    <span
                        key={pathToSegment}
                        className={`breadcrumb-item ${index === paths.length - 1 ? "active" : "text-primary"}`}
                        style={{ cursor: index === paths.length - 1 ? "default" : "pointer" }}
                        onClick={() => index < paths.length - 1 && setCurrentPath(pathToSegment)}
                    >
                        {segment}
                    </span>
                );
            })}
        </nav>
    );
};

export default Breadcrumb;
